import { Outlet } from 'react-router-dom';

export function Report() {
  return <Outlet />;
}
